'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (method) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var proto = Object.getPrototypeOf(this),
        ctr = proto.constructor,
        engineId = void 0,
        queryParams = void 0,
        syncOptions = void 0,
        Engine = void 0,
        _options$data = options.data,
        data = _options$data === undefined ? {} : _options$data;


    queryParams = _prepareQueryParams2.default.call(this, method, data);

    syncOptions = Object.assign({}, defaultOptions, options, queryParams);

    if (!syncOptions.protocol) {
        // null - skip protocol parsing
        // TODO MOVE PROTOCOL TO QUERYPARAMS
        syncOptions.protocol = typeof ctr.protocol !== 'undefined' ? ctr.protocol : _protocol2.default;
    }

    // TODO MOVE SYNC_ID OUTSIDE MODEL CLASS
    engineId = syncOptions.syncId || this.syncId || ctr.syncId || DEFAULT_SYNC_ENGINE;

    this.syncEngines = this.syncEngines || {};

    if (method === CONNECT_METHOD_NAME) {
        // Engine is active
        if (this.syncEngines[engineId]) {
            if (this.syncEngines[engineId].isOpen()) {
                return this.syncEngines[engineId];
            } else {
                // Engine is initiated but closed
                return this.syncEngines[engineId].connect();
            }
        } else {
            // new connection
            Engine = _sync2.default.getEngine(engineId);

            if (Engine) {
                var _onMessage = syncOptions.onMessage,
                    _onError = syncOptions.onError;

                this.syncEngines[engineId] = new Engine(Object.assign({}, syncOptions, {
                    onMessage: function onMessage(data) {
                        if (_this instanceof _dataCollection2.default) {
                            // collection will be parsed any time when .set is called with 'read' parser
                            if (method !== 'read' && syncOptions.parse === true && typeof _this.parse === 'function') {
                                data = _this.parse(data, syncOptions, method);
                            }
                        } else {
                            if (syncOptions.parse === true && typeof _this.parse === 'function') {
                                data = _this.parse(data, syncOptions, method);
                            }
                        }

                        if (typeof _this.syncResolve === 'function') {
                            _this.syncResolve(data, syncOptions);
                        }

                        if (typeof _onMessage === 'function') {
                            _onMessage(data);
                        }
                    },
                    onError: function onError(error) {
                        if (syncOptions.parse === true && typeof _this.parse === 'function') {
                            error = _this.parse(error, syncOptions, 'error');
                        }

                        if (typeof _onError === 'function') {
                            _onError(error);
                        }
                    }
                })).connect();

                return this.syncEngines[engineId];
            } else {
                if (process && process.env.NODE_ENV !== 'production') {
                    console.warn('Sync. Engine ' + engineId + ' not found.');
                }

                return Promise.reject('Sync. Engine ' + engineId + ' not found.');
            }
        }
        // send message
    } else if (method === SEND_METHOD_NAME) {
        if (this.syncEngines[engineId] && this.syncEngines[engineId].isOpen()) {
            return this.syncEngines[engineId].send(syncOptions.data, syncOptions);
        } else {
            if (process && process.env.NODE_ENV !== 'production') {
                console.warn('Sync. Cannon send data to closed stream.');
            }

            return Promise.reject('Sync. Cannon send data to closed stream.');
        }
    } else {
        if (process && process.env.NODE_ENV !== 'production') {
            console.warn('Sync. Unresolved stream method ' + method + '.');
        }

        return Promise.reject('Sync. Unresolved stream method ' + method + '.');
    }
};

var _protocol = require('../../../common/backbone/sync/protocol.default');

var _protocol2 = _interopRequireDefault(_protocol);

var _sync = require('../../../common/backbone/sync/sync');

var _sync2 = _interopRequireDefault(_sync);

var _prepareQueryParams = require('./prepareQueryParams');

var _prepareQueryParams2 = _interopRequireDefault(_prepareQueryParams);

var _dataCollection = require('../../../common/backbone/dataCollection');

var _dataCollection2 = _interopRequireDefault(_dataCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
    parse: true,
    validate: false
};

var DEFAULT_SYNC_ENGINE = 'pooling',
    CONNECT_METHOD_NAME = 'connect',
    SEND_METHOD_NAME = 'send';